import { render, staticRenderFns } from "./AssigneesSelectorFilter.vue?vue&type=template&id=4a800fda&scoped=true"
import script from "./AssigneesSelectorFilter.vue?vue&type=script&lang=js"
export * from "./AssigneesSelectorFilter.vue?vue&type=script&lang=js"
import style0 from "./AssigneesSelectorFilter.vue?vue&type=style&index=0&id=4a800fda&prod&scoped=true&lang=scss"
import style1 from "./AssigneesSelectorFilter.vue?vue&type=style&index=1&id=4a800fda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a800fda",
  null
  
)

export default component.exports